(function () {
  var sections = document.querySelectorAll("[data-diagnox-questions]");
  if (!sections.length) return;

  var mobileBreakpoint = 768;

  function getItemsPerPage(section) {
    var desktop = parseInt(section.getAttribute("data-items-per-page-desktop"), 10) || 6;
    var mobile = parseInt(section.getAttribute("data-items-per-page-mobile"), 10) || 5;
    return window.innerWidth <= mobileBreakpoint ? mobile : desktop;
  }

  function animatePanel(panel, open) {
    if (!panel) return;
    var targetHeight = panel.scrollHeight;

    if (open) {
      panel.style.maxHeight = "0px";
      requestAnimationFrame(function () {
        panel.style.maxHeight = targetHeight + "px";
      });
      return;
    }

    panel.style.maxHeight = targetHeight + "px";
    requestAnimationFrame(function () {
      panel.style.maxHeight = "0px";
    });
  }

  function setItemOpen(item, open) {
    var trigger = item.querySelector("[data-question-trigger]");
    var panel = item.querySelector("[data-question-panel]");
    item.classList.toggle("is-open", open);
    if (trigger) trigger.setAttribute("aria-expanded", open ? "true" : "false");
    animatePanel(panel, open);
  }

  function renderPages(totalPages, currentPage, pagesWrap) {
    pagesWrap.innerHTML = "";
    var pages = [];

    if (totalPages <= 5) {
      for (var i = 1; i <= totalPages; i += 1) pages.push(i);
    } else if (currentPage <= 3) {
      pages = [1, 2, 3, "...", totalPages];
    } else if (currentPage >= totalPages - 2) {
      pages = [1, "...", totalPages - 2, totalPages - 1, totalPages];
    } else {
      pages = [1, "...", currentPage, "...", totalPages];
    }

    pages.forEach(function (value) {
      if (value === "...") {
        var ellipsis = document.createElement("span");
        ellipsis.className = "diagnox-questions__ellipsis";
        ellipsis.textContent = "...";
        pagesWrap.appendChild(ellipsis);
        return;
      }

      var button = document.createElement("button");
      button.type = "button";
      button.className = "diagnox-questions__page" + (value === currentPage ? " is-active" : "");
      button.textContent = String(value);
      button.setAttribute("data-page", String(value));
      pagesWrap.appendChild(button);
    });
  }

  sections.forEach(function (section) {
    var items = Array.prototype.slice.call(section.querySelectorAll("[data-question-item]"));
    var paginationWrap = section.querySelector("[data-pagination-wrap]");
    var prev = section.querySelector("[data-pagination-prev]");
    var next = section.querySelector("[data-pagination-next]");
    var pagesWrap = section.querySelector("[data-pagination-pages]");
    var readAllButton = section.querySelector("[data-read-all]");
    if (!items.length) return;
    // Two independent columns so opening an item never moves items in the other column.
    var list = section.querySelector("[data-question-list]");
    if (list && !list.querySelector(".diagnox-questions__col")) {
      var columns = [document.createElement("div"), document.createElement("div")];
      columns.forEach(function (col) {
        col.className = "diagnox-questions__col";
      });
      items.forEach(function (item, index) {
        item.style.setProperty("--q-order", index);
        columns[index % 2].appendChild(item);
      });
      columns.forEach(function (col) {
        list.appendChild(col);
      });
    }

    if (!paginationWrap || !prev || !next || !pagesWrap || !readAllButton) return;

    var currentPage = 1;
    var readAllMode = false;

    function visibleRange() {
      var perPage = getItemsPerPage(section);
      var start = (currentPage - 1) * perPage;
      var end = start + perPage;
      return { start: start, end: end, perPage: perPage };
    }

    function syncOpenStateForVisible() {
      var firstVisible = null;
      items.forEach(function (item) {
        if (item.style.display !== "none" && !firstVisible) firstVisible = item;
      });
      if (!firstVisible) return;

      var hasOpenVisible = items.some(function (item) {
        return item.style.display !== "none" && item.classList.contains("is-open");
      });

      // if (!hasOpenVisible) setItemOpen(firstVisible, true);
    }

    function syncPageUsecaseBorders() {
      if (!section.classList.contains("page_usecase")) return;

      items.forEach(function (item) {
        item.classList.remove("is-col-last");
      });

      var visibleItems = items.filter(function (item) {
        return item.style.display !== "none";
      });
      if (!visibleItems.length) return;

      var columnGroups = [];
      visibleItems.forEach(function (item) {
        var left = Math.round(item.getBoundingClientRect().left);
        var group = null;

        for (var i = 0; i < columnGroups.length; i += 1) {
          if (columnGroups[i].left === left) {
            group = columnGroups[i];
            break;
          }
        }

        if (!group) {
          group = { left: left, items: [] };
          columnGroups.push(group);
        }

        group.items.push(item);
      });

      columnGroups.sort(function (a, b) {
        return a.left - b.left;
      });

      columnGroups.forEach(function (group) {
        var lastItem = group.items[group.items.length - 1];
        if (lastItem) lastItem.classList.add("is-col-last");
      });
    }

    function applyPagination() {
      var perPage = getItemsPerPage(section);
      var totalPages = Math.max(1, Math.ceil(items.length / perPage));
      if (currentPage > totalPages) currentPage = totalPages;

      if (readAllMode) {
        items.forEach(function (item) {
          item.style.display = "";
        });
        paginationWrap.style.display = "none";
        readAllButton.style.display = "none";
        syncOpenStateForVisible();
        syncPageUsecaseBorders();
        return;
      }

      var range = visibleRange();
      items.forEach(function (item, index) {
        item.style.display = index >= range.start && index < range.end ? "" : "none";
        if (item.style.display === "none" && item.classList.contains("is-open")) {
          setItemOpen(item, false);
        }
      });

      renderPages(totalPages, currentPage, pagesWrap);
      prev.disabled = currentPage <= 1;
      next.disabled = currentPage >= totalPages;
      paginationWrap.style.display = totalPages > 1 ? "flex" : "none";
      readAllButton.style.display = totalPages > 1 ? "block" : "none";
      syncOpenStateForVisible();
      syncPageUsecaseBorders();
    }

    section.addEventListener("click", function (event) {
      var trigger = event.target.closest("[data-question-trigger]");
      if (trigger) {
        var item = trigger.closest("[data-question-item]");
        if (!item || item.style.display === "none") return;
        var isOpen = item.classList.contains("is-open");

        items.forEach(function (other) {
          if (other !== item && other.style.display !== "none" && other.classList.contains("is-open")) {
            setItemOpen(other, false);
          }
        });
        setItemOpen(item, !isOpen);
        if (section.classList.contains("page_usecase")) {
          requestAnimationFrame(function () {
            syncPageUsecaseBorders();
          });
        }
        return;
      }

      var pageButton = event.target.closest("[data-page]");
      if (pageButton) {
        var targetPage = parseInt(pageButton.getAttribute("data-page"), 10);
        if (!targetPage || targetPage === currentPage) return;
        currentPage = targetPage;
        applyPagination();
        return;
      }

      if (event.target.closest("[data-pagination-prev]")) {
        if (currentPage > 1) {
          currentPage -= 1;
          applyPagination();
        }
        return;
      }

      if (event.target.closest("[data-pagination-next]")) {
        var maxPages = Math.max(1, Math.ceil(items.length / getItemsPerPage(section)));
        if (currentPage < maxPages) {
          currentPage += 1;
          applyPagination();
        }
        return;
      }

      if (event.target.closest("[data-read-all]")) {
        readAllMode = true;
        applyPagination();
      }
    });

    window.addEventListener("resize", function () {
      if (readAllMode) return;
      applyPagination();
    });

    function openFirstAccordionIfEnabled() {
      if (section.getAttribute("data-open-first-accordion") !== "true") return;

      var firstVisible = null;
      items.forEach(function (item) {
        if (item.style.display !== "none" && !firstVisible) firstVisible = item;
      });

      if (!firstVisible) return;

      var trigger = firstVisible.querySelector("[data-question-trigger]");
      var panel = firstVisible.querySelector("[data-question-panel]");
      firstVisible.classList.add("is-open");
      if (trigger) trigger.setAttribute("aria-expanded", "true");
      if (panel) panel.style.maxHeight = panel.scrollHeight + "px";
    }

    applyPagination();
    requestAnimationFrame(function () {
      openFirstAccordionIfEnabled();
      syncPageUsecaseBorders();
    });
  });
})();
